import React, { Component } from 'react';

import { Icon } from 'semantic-ui-react';
import Button from './Button';

/**
 * @typedef {{
 *  title: string,
 *  titleStyle?: React.CSSProperties,
 *  children: JSX.Element,
 *  closeButton?: boolean,
 *  confirmButton?: {
 *    text: string,
 *    className?: string,
 *    style?: React.CSSProperties,
 *    action?: () => void,
 *    disabled?: boolean,
 *    loading?: boolean,
 *    icon?: {
 *      name: string,
 *      style?: React.CSSProperties,
 *      right?: boolean,
 *    }
 *  },
 *  customConfirm?: JSX.Element,
 *  cancelButton?: {
 *    text: string,
 *    action?: () => void
 *  },
 *  onClose?: () => void,
 *  style?: React.CSSProperties,
 *  className?: string,
 *  backgroundClassName?: string,
 *  buttonsStyle?: React.CSSProperties,
 *  noCancelButton?: boolean,
 *  headerComponents?: JSX.Element[] | JSX.Element,
 *  fixChildrenHeight?: boolean,
 *  modalStyle?: React.CSSProperties,
 *  id?: string,
 *  customCancel?: JSX.Element,
 *  cancelEnabled?: boolean
 * }} Props
 * @extends {Component<Props>}
 */
export default class Modal extends React.Component {
  /** @param {Props} props */
  constructor(props) {
    super(props);
    this.state = {
      contentHeight: null
    };
  }

  componentDidMount() {
    // @ts-ignore contentHeight is used to adjust the height of InfiniteScroll
    this.setState({ contentHeight: this.content.offsetHeight - 1 });
  }

  render() {
    const {
      title, titleStyle, children, closeButton, confirmButton, customConfirm,
      cancelButton, onClose, style, className, backgroundClassName, buttonsStyle,
      noCancelButton, headerComponents, fixChildrenHeight, modalStyle, id, customCancel,
    } = this.props;
    const { contentHeight } = this.state;

    const childrenWithSameHeight = React.cloneElement(
      children,
      { height: contentHeight || 300, ...children.props }
    );
    return (
      <div className={`modal-background ${backgroundClassName || ''}`} style={style} key={id || `modal-${title}`}>
        <div className={`modal ${className || ''}`} style={modalStyle}>
          <div className="modal-header" style={titleStyle}>
            <h3>{title}</h3>

            {closeButton && (
              <Icon
                onClick={() => {
                  if (onClose) onClose();
                }}
                className="times"
              />
            )}
          </div>

          {headerComponents && <div className="modal-controls">{headerComponents}</div>}

          <div className="modal-content" ref={(c) => { this.content = c; }}>
            {fixChildrenHeight ? childrenWithSameHeight : children}
          </div>

          <div className="modal-buttons" style={buttonsStyle}>
            {!noCancelButton && (customCancel || (
              <Button
                transparent
                type="button"
                {...cancelButton}
                onClick={() => {
                  if (cancelButton?.action) cancelButton.action();
                  if (onClose) onClose();
                }}
                action=""
              />
            ))}
            {confirmButton ? (
              <Button
                type="button"
                {...confirmButton}
                onClick={async () => {
                  if (confirmButton?.action) await confirmButton.action();
                  if (onClose) onClose();
                }}
              />
            ) : customConfirm}
          </div>
        </div>
      </div>
    );
  }
}
